import { question } from "./SMSTpv.types"
const idRemover = (id: string) => {
  let newId = "";
  for (let i = 0; i < id.length - 1; i++) {
    newId += id[i];
  }
  return newId;
};

export const generateSaveAnswerPayload = (payload: question[]) => {
  return payload.map(
    ({ id, questionType, question, isYes, isNo, dtmfAnswer, enrollmentPosition }: question) => {
      const payload = {
        questionId: idRemover(id),
        questionType,
        questionDescription: question,
        enrollmentPosition
      }
      if (questionType === 'SPEECH_ONLY') {
        return {
          ...payload,
          description: "" //same state used for speech only
        }
      } else if (questionType === 'VOICE_RESPONSE') {
        return {
          ...payload,
          description: dtmfAnswer //same state used for speech only
        }
      }
      else if (questionType === 'YESNO') {
        return {
          ...payload,
          description: isYes ? 'yes.' : 'no.',
        }
      } else if (questionType === 'DTMF') {
        return {
          ...payload,
          description: dtmfAnswer,
        }
      } else if (questionType === 'BOTH_OPTION') {
        if (isYes || isNo) {
          return {
            ...payload,
            description: isYes ? 'yes.' : 'no.',
          }
        } else {
          return {
            ...payload,
            description: dtmfAnswer,
          }
        }
      }
    }
  )
}